import Vue from 'vue'

import KonamiCode from './konami-code'

// Custom components
import BounceSpinner from '@/components/BounceSpinner'
import ParticlesJS from '@/components/ParticlesJS'
import SocialNetworks from '@/components/SocialNetworks'
import BackTop from '@/components/BackTop'
import Revealer from '@/components/Revealer'
import SectionTitle from '@/components/SectionTitle'

//
// Third party stuff
//
// vue-progressbar (https://github.com/hilongjw/vue-progressbar)
import VueProgressBar from 'vue-progressbar'
// vue-in-viewport (https://github.com/BKWLD/vue-in-viewport-directive)
import inViewportDirective from 'vue-in-viewport-directive'
// vue-on-click-outside (https://github.com/kmohrf/vue-on-click-outside)
import { directive as onClickOutside } from 'vue-on-click-outside'
// vue-touch (https://github.com/vuejs/vue-touch)
import VueTouch from 'vue-touch'

//
// Usage
//
Vue.use(VueProgressBar)
Vue.use(VueTouch, { name: 'v-touch' })
Vue.directive('in-viewport', inViewportDirective)
Vue.directive('on-click-outside', onClickOutside)

// Register custom components for general usage
const myComponents = {
  KonamiCode,
  ParticlesJS,
  SectionTitle,
  Revealer,
  SocialNetworks,
  BounceSpinner,
  BackTop
}
Object.keys(myComponents).forEach((key) => {
  Vue.component(key, myComponents[key])
})



// WEBPACK FOOTER //
// ./src/plugins/index.js